import Grid from "@mui/material/Grid"

import MDBox from "components/MDBox"

import { useEffect, useState } from "react"
import DashboardLayout from "monitor/LayoutContainers/DashboardLayout"
import DashboardNavbar from "monitor/Navbars/DashboardNavbar"
import Footer from "monitor/Footer"
import ComplexStatisticsCard from "monitor/Cards/StatisticsCards/ComplexStatisticsCard"
import config from "config"
import FilterCard from "./FilterCard"
import ReportsBarChart from "monitor/charts/BarCharts/ReportsBarChart"
import { Badge, Icon, IconButton } from "@mui/material"
import MDTypography from "components/MDTypography"
import DeviceStatisticsCard from "monitor/Cards/StatisticsCards/DeviceStatisticsCard"

function Dashboard() {
  const [recoIniDate, setRecoIniDate] = useState("")
  const [recoEndDate, setRecoEndDate] = useState("")
  const [reportsBarChartData2, setReportsBarChartData2] = useState({})

  const [devices, setDevices] = useState([0, 0])
  const [deviceStatus, setDeviceStatus] = useState({ total: 0, online: 0, offline: 0 })

  const [auth, setAuth] = useState([0, 0])
  const [authAmount, setAuthAmount] = useState(0)

  const [reco, setReco] = useState([0, 0])
  const [recoAmount, setRecoAmount] = useState(0)
  const [openDashboardFilter, setOpenDashboardFilter] = useState(false)
  const [filterDashboard, setFilterDashboard] = useState(false)

  const [authIniDate, setAuthIniDate] = useState("")
  const [authEndDate, setAuthEndDate] = useState("")
  const [reportsBarChartData, setReportsBarChartData] = useState({})

  useEffect(() => {
    fetchDevices()
    fetchDeviceStatus()
    fetchAuths()
    fetchReco()

    const authDateRange = calculateWeekRange(new Date())
    setAuthIniDate(authDateRange.start)
    setAuthEndDate(authDateRange.end)
    fetchAuthsChart(
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      authDateRange.start,
      authDateRange.end
    )

    const recoDateRange = calculateWeekRange(new Date())
    setRecoIniDate(recoDateRange.start)
    setRecoEndDate(recoDateRange.end)
    fetchRecoChart(
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      recoDateRange.start,
      recoDateRange.end
    )
  }, [])

  const recoChartNext = async () => {
    const [day, month, year] = recoIniDate.split("/").map(Number) // Convert parts to numbers
    const parsedDate = new Date(year, month - 1, day)

    const recoIniDateOld = new Date(parsedDate)
    recoIniDateOld.setDate(parsedDate.getDate() + 7)

    const recoDateRange = calculateWeekRange(recoIniDateOld)
    setRecoIniDate(recoDateRange.start)
    setRecoEndDate(recoDateRange.end)
    fetchRecoChart(
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      recoDateRange.start,
      recoDateRange.end
    )
  }

  const recoChartPrevious = async () => {
    const [day, month, year] = recoIniDate.split("/").map(Number) // Convert parts to numbers
    const parsedDate = new Date(year, month - 1, day)

    const recoIniDateOld = new Date(parsedDate)
    recoIniDateOld.setDate(parsedDate.getDate() - 7)
    const recoDateRange = calculateWeekRange(recoIniDateOld)
    setRecoIniDate(recoDateRange.start)
    setRecoEndDate(recoDateRange.end)
    fetchRecoChart(
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      recoDateRange.start,
      recoDateRange.end
    )
  }

  //Dispositivos
  const fetchDevices = async (
    empresaId,
    sucursalId,
    eventoId,
    zonaId,
    ip,
    nombreDispositivo,
    fechaDesde,
    fechaHasta
  ) => {
    try {
      const token = (sessionStorage.getItem("token") || localStorage.getItem("token"))
      setFilterDashboard(false)
      let apiUrl = `${config.api.baseURL}/dashboard/devices?`

      if (empresaId) {
        apiUrl += `empresaId=${encodeURIComponent(empresaId)}&`
        setFilterDashboard(true)
      }
      if (sucursalId) {
        apiUrl += `sucursalId=${encodeURIComponent(sucursalId)}&`
        setFilterDashboard(true)
      }
      if (eventoId) {
        apiUrl += `sucursalId=${encodeURIComponent(eventoId)}&`
        setFilterDashboard(true)
      }
      if (zonaId) {
        apiUrl += `zonaId=${encodeURIComponent(zonaId)}&`
        setFilterDashboard(true)
      }
      if (fechaDesde) {
        apiUrl += `fechaDesde=${encodeURIComponent(fechaDesde)}&`
        setFilterDashboard(true)
      }
      if (fechaHasta) {
        apiUrl += `fechaHasta=${encodeURIComponent(fechaHasta)}&`
        setFilterDashboard(true)
      }
      if (ip) {
        apiUrl += `ip=${encodeURIComponent(ip)}&`
        setFilterDashboard(true)
      }
      if (nombreDispositivo) {
        apiUrl += `nombreDispositivo=${encodeURIComponent(nombreDispositivo)}&`
        setFilterDashboard(true)
      }
      console.log(apiUrl)
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      })

      if (response.status === 200) {
        const result = await response.json()
        console.log(result)
        setDevices(result)
      }
    } catch (error) {
      console.error("Error fetching data:", error)
    }
  }

  const fetchDeviceStatus = async (
    empresaId,
    sucursalId,
    eventoId,
    zonaId,
    ip,
    nombreDispositivo
  ) => {
    try {
      const token = (sessionStorage.getItem("token") || localStorage.getItem("token"))
      let apiUrl = `${config.api.baseURL}/dashboard/devices/status?`
      if (empresaId) apiUrl += `empresaId=${encodeURIComponent(empresaId)}&`
      if (sucursalId) apiUrl += `sucursalId=${encodeURIComponent(sucursalId)}&`
      if (eventoId) apiUrl += `eventoId=${encodeURIComponent(eventoId)}&`
      if (zonaId) apiUrl += `zonaId=${encodeURIComponent(zonaId)}&`
      if (ip) apiUrl += `ip=${encodeURIComponent(ip)}&`
      if (nombreDispositivo) apiUrl += `nombreDispositivo=${encodeURIComponent(nombreDispositivo)}&`

      const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      })

      if (response.status === 200) {
        const result = await response.json()
        setDeviceStatus(result)
      }
    } catch (error) {
      console.error("Error fetching device status:", error)
    }
  }

  const fetchAuths = async (
    empresaId,
    sucursalId,
    eventoId,
    zonaId,
    ip,
    nombreDispositivo,
    fechaDesde,
    fechaHasta
  ) => {
    try {
      const token = (sessionStorage.getItem("token") || localStorage.getItem("token"))
      let apiUrl = `${config.api.baseURL}/dashboard/auths?`
      setFilterDashboard(false)
      if (empresaId) {
        apiUrl += `empresaId=${encodeURIComponent(empresaId)}&`
        setFilterDashboard(true)
      }
      if (sucursalId) {
        apiUrl += `sucursalId=${encodeURIComponent(sucursalId)}&`
        setFilterDashboard(true)
      }
      if (eventoId) {
        apiUrl += `eventoId=${encodeURIComponent(eventoId)}&`
        setFilterDashboard(true)
      }
      if (zonaId) {
        apiUrl += `zonaId=${encodeURIComponent(zonaId)}&`
        setFilterDashboard(true)
      }
      if (fechaDesde) {
        apiUrl += `fechaDesde=${encodeURIComponent(fechaDesde.toISOString())}&`
        setFilterDashboard(true)
      }
      if (fechaHasta) {
        apiUrl += `fechaHasta=${encodeURIComponent(fechaHasta.toISOString())}&`
        setFilterDashboard(true)
      }
      if (ip) {
        apiUrl += `ip=${encodeURIComponent(ip)}&`
        setFilterDashboard(true)
      }
      if (nombreDispositivo) {
        apiUrl += `nombreDispositivo=${encodeURIComponent(nombreDispositivo)}&`
        setFilterDashboard(true)
      }

      const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      })

      if (response.status === 200) {
        const result = await response.json()
        setAuth(result) // Set the new auth data

        const value = (result[0] / (result[1] == 0 ? 1 : result[1])) * 100
        setAuthAmount(value - 100)
      }
    } catch (error) {
      console.error("Error fetching data:", error)
    }
  }

  const handleFilterDashbaord = async () => {
    setOpenDashboardFilter(true)
  }

  const handleCloseFilterDashbaord = async () => {
    setOpenDashboardFilter(false)
  }

  const handleSearchDashboard = (
    empresaId,
    sucursalId,
    zonaId,
    eventoId,
    ip,
    nombreDispositivo,
    fechaDesde,
    fechaHasta
  ) => {
    fetchReco(empresaId, sucursalId, zonaId, ip, nombreDispositivo, fechaDesde, fechaHasta)
    fetchAuths(
      empresaId,
      sucursalId,
      eventoId,
      zonaId,
      ip,
      nombreDispositivo,
      fechaDesde,
      fechaHasta
    )
    fetchDevices(
      empresaId,
      sucursalId,
      eventoId,
      zonaId,
      ip,
      nombreDispositivo,
      fechaDesde,
      fechaHasta
    )
    fetchDeviceStatus(empresaId, sucursalId, eventoId, zonaId, ip, nombreDispositivo)
    fetchRecoChart(
      empresaId,
      sucursalId,
      eventoId,
      zonaId,
      ip,
      nombreDispositivo,
      recoIniDate,
      recoEndDate
    )
    fetchAuthsChart(
      empresaId,
      sucursalId,
      eventoId,
      zonaId,
      ip,
      nombreDispositivo,
      authIniDate,
      authEndDate
    )
    handleCloseFilterDashbaord()
  }

  const fetchReco = async (
    empresaId,
    sucursalId,
    zonaId,
    ip,
    nombreDispositivo,
    fechaDesde,
    fechaHasta
  ) => {
    try {
      const token = (sessionStorage.getItem("token") || localStorage.getItem("token"))
      let apiUrl = `${config.api.baseURL}/dashboard/recognition?`

      setFilterDashboard(false)
      if (empresaId) {
        apiUrl += `empresaId=${encodeURIComponent(empresaId)}&`
        setFilterDashboard(true)
      }
      if (sucursalId) {
        apiUrl += `sucursalId=${encodeURIComponent(sucursalId)}&`
        setFilterDashboard(true)
      }
      if (zonaId) {
        apiUrl += `zonaId=${encodeURIComponent(zonaId)}&`
        setFilterDashboard(true)
      }
      if (fechaDesde) {
        apiUrl += `fechaDesde=${encodeURIComponent(fechaDesde.toISOString())}&`
        setFilterDashboard(true)
      }
      if (fechaHasta) {
        apiUrl += `fechaHasta=${encodeURIComponent(fechaHasta.toISOString())}&`
        setFilterDashboard(true)
      }
      if (ip) {
        apiUrl += `ip=${encodeURIComponent(ip)}&`
        setFilterDashboard(true)
      }
      if (nombreDispositivo) {
        apiUrl += `nombreDispositivo=${encodeURIComponent(nombreDispositivo)}&`
        setFilterDashboard(true)
      }
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      })

      if (response.status === 200) {
        const result = await response.json()
        setReco(result)
        const value = (reco[0] / (reco[1] == 0 ? 1 : reco[1])) * 100
        setRecoAmount(value - 100.0)
      }
    } catch (error) {
      console.error("Error fetching data:", error)
    }
  }

  const authChartPrevious = async () => {
    const [day, month, year] = authIniDate.split("/").map(Number) // Convert parts to numbers
    const parsedDate = new Date(year, month - 1, day)

    const authIniDateOld = new Date(parsedDate)
    authIniDateOld.setDate(parsedDate.getDate() - 7)
    const authDateRange = calculateWeekRange(authIniDateOld)
    setAuthIniDate(authDateRange.start)
    setAuthEndDate(authDateRange.end)
    fetchAuthsChart(
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      authDateRange.start,
      authDateRange.end,
      true
    )
  }

  const fetchAuthsChart = async (
    empresaId,
    sucursalId,
    eventoId,
    zonaId,
    ip,
    nombreDispositivo,
    iniDate,
    endDate
  ) => {
    try {
      const token = (sessionStorage.getItem("token") || localStorage.getItem("token"))
      let apiUrl = `${config.api.baseURL}/dashboard/auths/chart?`

      setFilterDashboard(false)
      if (empresaId) {
        apiUrl += `empresaId=${encodeURIComponent(empresaId)}&`
        setFilterDashboard(true)
      }
      if (sucursalId) {
        apiUrl += `sucursalId=${encodeURIComponent(sucursalId)}&`
        setFilterDashboard(true)
      }
      if (eventoId) {
        apiUrl += `eventoId=${encodeURIComponent(eventoId)}&`
        setFilterDashboard(true)
      }
      if (zonaId) {
        apiUrl += `zonaId=${encodeURIComponent(zonaId)}&`
        setFilterDashboard(true)
      }
      if (ip) {
        apiUrl += `ip=${encodeURIComponent(ip)}&`
        setFilterDashboard(true)
      }
      if (nombreDispositivo) {
        apiUrl += `nombreDispositivo=${encodeURIComponent(nombreDispositivo)}&`
        setFilterDashboard(true)
      }
      if (iniDate) {
        apiUrl += `iniDate=${encodeURIComponent(iniDate)}&`
      }
      if (endDate) {
        apiUrl += `endDate=${encodeURIComponent(endDate)}&`
      }

      const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      })

      if (response.status === 200) {
        const result = await response.json()
        setReportsBarChartData(result)
      }
    } catch (error) {
      console.error("Error fetching data:", error)
    }
  }

  const authChartNext = async () => {
    //tomamos 7 dias atras
    const [day, month, year] = authIniDate.split("/").map(Number) // Convert parts to numbers
    const parsedDate = new Date(year, month - 1, day)

    const authIniDateOld = new Date(parsedDate)
    authIniDateOld.setDate(parsedDate.getDate() + 7)

    const authDateRange = calculateWeekRange(authIniDateOld)
    setAuthIniDate(authDateRange.start)
    setAuthEndDate(authDateRange.end)
    fetchAuthsChart(
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      authDateRange.start,
      authDateRange.end
    )
  }

  const calculateWeekRange = (date) => {
    const currentDay = date.getDay() // 0 for Sunday, 1 for Monday, etc.

    const startOfWeek = new Date(date)
    startOfWeek.setDate(date.getDate() - currentDay)

    const endOfWeek = new Date(startOfWeek)
    endOfWeek.setDate(startOfWeek.getDate() + 6)
    return {
      start: formatDate(startOfWeek),
      end: formatDate(endOfWeek),
    }
  }

  const formatDate = (date) => {
    const day = String(date.getDate()).padStart(2, "0")
    const month = String(date.getMonth() + 1).padStart(2, "0") // Months are 0-based
    const year = date.getFullYear()
    return `${day}/${month}/${year}`
  }

  const fetchRecoChart = async (
    empresaId,
    sucursalId,
    eventoId,
    zonaId,
    ip,
    nombreDispositivo,
    iniDate,
    endDate
  ) => {
    try {
      const token = (sessionStorage.getItem("token") || localStorage.getItem("token"))
      let apiUrl = `${config.api.baseURL}/dashboard/reco/chart?`

      setFilterDashboard(false)
      if (empresaId) {
        apiUrl += `empresaId=${encodeURIComponent(empresaId)}&`
        setFilterDashboard(true)
      }
      if (sucursalId) {
        apiUrl += `sucursalId=${encodeURIComponent(sucursalId)}&`
        setFilterDashboard(true)
      }
      if (eventoId) {
        apiUrl += `eventoId=${encodeURIComponent(eventoId)}&`
        setFilterDashboard(true)
      }
      if (zonaId) {
        apiUrl += `zonaId=${encodeURIComponent(zonaId)}&`
        setFilterDashboard(true)
      }
      if (iniDate) {
        apiUrl += `iniDate=${encodeURIComponent(iniDate)}&`
      }
      if (endDate) {
        apiUrl += `endDate=${encodeURIComponent(endDate)}&`
      }
      if (ip) {
        apiUrl += `ip=${encodeURIComponent(ip)}&`
        setFilterDashboard(true)
      }
      if (nombreDispositivo) {
        apiUrl += `nombreDispositivo=${encodeURIComponent(nombreDispositivo)}&`
        setFilterDashboard(true)
      }

      const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      })

      if (response.status === 200) {
        const result = await response.json()
        setReportsBarChartData2(result)
      }
    } catch (error) {
      console.error("Error fetching data:", error)
    }
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3} sx={{ height: "70vh" }}>
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <MDTypography variant="h6" fontWeight="bold">
              <IconButton
                size="large"
                sx={{ pb: 2 }}
                color="success"
                onClick={handleFilterDashbaord}
              >
                {filterDashboard && (
                  <Badge
                    badgeContent={""}
                    color="error"
                    overlap="circular"
                    sx={{
                      "& .MuiBadge-badge": {
                        fontSize: "8px",
                        minWidth: "12px",
                        height: "12px",
                      },
                    }}
                  >
                    <Icon>filter_alt</Icon>
                  </Badge>
                )}
                {!filterDashboard && <Icon>filter_alt</Icon>}
              </IconButton>{" "}
              Filtrar
            </MDTypography>
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <MDBox mb={1.5}>
              <DeviceStatisticsCard
                color="warning"
                icon="monitor_heart"
                title="Total encontrados"
                count={deviceStatus.total}
                filter={filterDashboard}
                percentage={{
                  color: "warning",
                  amountOnline: deviceStatus.online,
                  amountOffline: deviceStatus.offline,
                  label: "Dispositivos",
                }}
                filterClick={handleFilterDashbaord}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                icon="login"
                title="Ingresos"
                showArrow={true}
                count={auth[0].toLocaleString("es-PY")}
                filter={filterDashboard}
                color="success"
                percentage={{
                  color: "success",
                  amount: Math.abs(authAmount).toLocaleString("es-PY", {
                    maximumFractionDigits: 2, // Adjust for decimals
                  }),
                  label: `% ${authAmount > 0 ? "más" : "menos"} que la semana anterior`,
                }}
                filterClick={handleFilterDashbaord}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="error"
                icon="videocam"
                title="Reconocimientos"
                showArrow={true}
                count={reco[0].toLocaleString("es-PY")}
                filter={filterDashboard}
                percentage={{
                  color: "error",
                  amount: Math.abs(recoAmount).toLocaleString("es-PY", {
                    maximumFractionDigits: 2, // Adjust for decimals
                  }),
                  label: `% ${recoAmount > 0 ? "más" : "menos"} que la semana anterior`,
                }}
                filterClick={handleFilterDashbaord}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <MDBox mb={3}>
              <ReportsBarChart
                color="success"
                title="Ingresos por dia"
                description="Total de ingresos por dia de la semana"
                dateIni={authIniDate}
                dateEnd={authEndDate}
                chart={reportsBarChartData}
                filter={filterDashboard}
                onPreviousClick={authChartPrevious}
                onNextClick={authChartNext}
                filterClick={handleFilterDashbaord}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <MDBox mb={3}>
              <ReportsBarChart
                color="info"
                title="Reconocimientos por dia"
                description="Total de reconocimientos por dia de la semana"
                dateIni={recoIniDate}
                dateEnd={recoEndDate}
                chart={reportsBarChartData2}
                filter={filterDashboard}
                onNextClick={recoChartNext}
                onPreviousClick={recoChartPrevious}
                filterClick={handleFilterDashbaord}
              />
            </MDBox>
          </Grid>
          <FilterCard
            key="filterDashboard"
            title="DASHBOARD"
            open={openDashboardFilter}
            onClose={handleCloseFilterDashbaord}
            onSearch={handleSearchDashboard}
          />
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  )
}

export default Dashboard
